import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { PlanningTargetCalcRequestErrorProps } from './types';
import { SavePlanningAndTargetConfigError } from '@bechtel/types';

const getErrorMessage = (error: PlanningTargetCalcRequestErrorProps['savePlanningAndTargetConfigError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured. Please close button and try again.</Trans>;
  }
  switch (error) {
    case SavePlanningAndTargetConfigError.NOT_FOUND:
      return <Trans>Project Config not found.</Trans>;
    case SavePlanningAndTargetConfigError.INVALID_VALUE:
      return <Trans>Invalid Project Config.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

const PlanningTargetCalcRequestError: FC<PlanningTargetCalcRequestErrorProps> = ({
  savePlanningAndTargetConfigError,
  close,
}) => {
  return (
    <Modal
      visible
      size={ModalSize.DEFAULT}
      data-testid="update-planning-target-calc-request-error"
      style={{ width: '552px', height: '275px' }}
    >
      <ModalHeader title={t`Planning &amp; Target Calculations Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(savePlanningAndTargetConfigError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
export default PlanningTargetCalcRequestError;
